// Traducción de los códigos de negocio que devuelve `mp-create-preference`.
//
// Pura y aparte del componente para poder verificarla: el mapeo vive en un
// único sitio y se aplica igual venga el código en el body de una respuesta
// 2xx o dentro de un FunctionsHttpError.

export type MpPreferenceErrorCode = 'PHONE_LIMIT' | 'PRECHECK_UNAVAILABLE';

/**
 * Mensaje para el cliente, o `null` si el código no es uno de los previstos
 * (en cuyo caso quien llama conserva su fallback genérico).
 *
 * PHONE_LIMIT cubre hoy dos reglas distintas -- rate limit horario y citas
 * futuras activas -- bajo el mismo código, así que el texto no afirma la
 * causa: decir "ya tienes el máximo de reservas" sería falso en el primer caso.
 */
export function mpPreferenceErrorMessage(code: string | null | undefined): string | null {
  if (!code) return null;
  if (code.includes('PHONE_LIMIT')) {
    return 'No podemos procesar otra reserva con este número en este momento. Intenta más tarde o contacta al negocio.';
  }
  if (code.includes('PRECHECK_UNAVAILABLE')) {
    return 'No pudimos validar tu reserva en este momento. Intenta nuevamente en unos minutos.';
  }
  return null;
}
